import { PulseLoader } from "react-spinners";
import { crossWhite, TickIcon, FailIcon, calendardate } from "./ImageImport";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { useState } from "react";
import { UserNotFound } from "../pages/userNotFound";

export function Loader({ loader }) {
  return (
    <>
      {loader == true && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}
    </>
  );
}

export const logoutFunction = (status) => {
  if (status === 403) {
    window.location.pathname = "/usernotfound";
  }
  if (status === 401) {
    window.location.pathname = "/sessionexpired";
  }
};

export function ToastMessageFailure({
  messageShow,
  isMobile,
  messageText,
  handleClose,
}) {
  return (
    <>
      {messageShow && (
        <div
          className={`${
            isMobile ? "" : "min-455px"
          } ${`failed-message text-14-normal-600 pl-10 pr-20 `}`}
        >
          <img src={FailIcon} className="img-failicon" />
          {messageText}
          <img
            className={`${
              isMobile ? `pr-10` : `pr-30`
            } ${"cursor-pointer float-right pt-1 pl-15"}`}
            onClick={() => handleClose()}
            src={crossWhite}
          />
        </div>
      )}
    </>
  );
}

export function ToastMessageSuccess({
  messageShow,
  isMobile,
  messageText,
  handleClose,
}) {
  return (
    <>
      {messageShow && (
        <div
          className={` ${
            isMobile ? "success-message-mob" : "min-455px pb-1"
          } ${`success-message text-14-normal-600 pl-10 pr-20`}`}
        >
          <img src={TickIcon} className={!isMobile ? "top-margin-10px" : ""} />
          {messageText}
          <img
            className={`${
              isMobile ? `pr-10 mt-2` : `pr-30 mt-1`
            } cursor-pointer float-right`}
            onClick={() => handleClose()}
            src={crossWhite}
          />
        </div>
      )}
    </>
  );
}

export function DateCustomPicker({ isError, value, setValue }) {
  const handleInputAddEdit = (e) => {
    setValue(e);
  };

  return (
    <>
      <KeyboardDatePicker
        autoOk
        variant="inline"
        inputVariant="outlined"
        className={isError ? "requireddate w-100" : "w-100 form-control"}
        emptyLabel="dd-mmm-yyyy"
        keyboardIcon={<img src={calendardate} />}
        format="dd-MMM-yyyy"
        value={value ? value : null}
        size="small"
        id="joinedDateId"
        onChange={handleInputAddEdit}
      />
    </>
  );
}
